<template>
  <el-card shadow="never">
    <template slot="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: $root.getDashboardPath() }">Dashboard</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Facility Finance' }">Finance</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'Facility Finance Balance Sheet'}">
          {{ $root.getHeader() }} Finance Balance Sheet
        </el-breadcrumb-item>
      </el-breadcrumb>
    </template>

    <el-card shadow="never" v-loading="loading">
       <el-row>
         <el-col class="date-picker">
          <el-date-picker
           v-model="date"
           @change="getBalanceSheet"
           type="month"
           placeholder="Select a month"
          />
          <el-button type="primary" round @click="exportData" :disabled="exportDisabled">Export</el-button>
         </el-col>
       </el-row>
     </el-card>

     <el-row :gutter="24">
       <br/>
       <el-col :span="8">
          <el-card
            :body-style="{background: 'linear-gradient(35deg, #009aca, #0c3da7)' }"
            v-loading="loading"
          >
            <div slot="header">
              <h4 class="hero-head">Deposits On Hand</h4>
            </div>
            <div>
              <h4 class="hero-text">
                {{ totalDepositPaid | currencySign($root.state.facilityData)}}
              </h4>
            </div>
          </el-card>
       </el-col>
       <el-col :span="8">
          <el-card
            :body-style="{background: 'linear-gradient(35deg, #009aca, #0c3da7)' }"
            v-loading="loading"
          >
            <div slot="header">
              <h4 class="hero-head">Prepaid / Held Funds</h4>
            </div>
            <div>
              <h4 class="hero-text">
                {{ totalPrepaidRent | currencySign($root.state.facilityData) }}
              </h4>
            </div>
          </el-card>
       </el-col>
       <el-col :span="8">
          <el-card
            :body-style="{background: 'linear-gradient(35deg, #009aca, #0c3da7)' }"
            v-loading="loading"
          >
            <div slot="header">
              <h4 class="hero-head">Receivables</h4>
            </div>
            <div>
              <h4 class="hero-text">
                {{ totalReceivables | currencySign($root.state.facilityData) }}
              </h4>
            </div>
          </el-card>
       </el-col>
     </el-row>

     <el-row v-if="true" :gutter="24">
       <el-col :span="8">
        <br/>
        <el-collapse :value="deposits.length ? '1' : ''">
          <el-collapse-item title="Deposit" name="1">
             <el-card>
               <el-table
                 @row-click="routeToCustomer"
                 :data="deposits"
                 v-loading="loading"
                 empty-text="No Data"
                 @sort-change="row => sortTable(row, deposits)"
                >
                <el-table-column label="Customer" prop="customerData.company" sortable></el-table-column>
                <el-table-column label="Deposit Amount" prop="totalDepositPaid" sortable>
                  <template slot-scope="scope">
                    {{  scope.row.totalDepositPaid | currencySign($root.state.facilityData) }}
                  </template>
                </el-table-column>
               </el-table>
             </el-card>
          </el-collapse-item>
        </el-collapse>
       </el-col>

       <el-col :span="8">
        <br/>
        <el-collapse :value="facilityAccounts.length ? '1' : ''">
          <el-collapse-item title="Wallet" name="1">
             <el-card>
               <el-table
                 @row-click="routeToCustomer"
                 :data="facilityAccounts"
                 v-loading="loading"
                 empty-text="No Data"
                 @sort-change="row => sortTable(row, facilityAccounts)"
                >
                <el-table-column label="Customer" prop="customerData.company" sortable></el-table-column>
                <el-table-column label="Wallet Amount" prop="balance" sortable>
                  <template slot-scope="scope">
                    {{  scope.row.balance | currencySign($root.state.facilityData) }}
                  </template>
                </el-table-column>
               </el-table>
             </el-card>
          </el-collapse-item>
        </el-collapse>
       </el-col>

       <el-col :span="8">
        <br/>
        <el-collapse :value="receivables.length ? '1' : ''">
          <el-collapse-item title="Receivables" name="1">
             <el-card>
               <el-table
                 @row-click="routeToCustomer"
                 :data="receivables"
                 v-loading="loading"
                 empty-text="No Data"
                 @sort-change="row => sortTable(row, receivables)"
                >
                <el-table-column label="Customer" prop="customerData.company" sortable></el-table-column>
                <el-table-column label="Total Due" prop="totalDue" sortable>
                  <template slot-scope="scope">
                    {{  scope.row.totalDue | currencySign($root.state.facilityData) }}
                  </template>
                </el-table-column>
               </el-table>
             </el-card>
          </el-collapse-item>
        </el-collapse>
       </el-col>
     </el-row>
  </el-card>
</template>


<script>
import axios from 'axios';
import { ADMIN_API_BASE } from '../env';
import { exportToCsvV2, saveCsv } from '../utils/exportToCsv';

export default {
  name: 'FacilityBalanceSheet',
  props: {
    facility: { type: String, required: true },
  },
  watch: {
    async facility() {
      this.facilityAccounts = [];
      this.deposits = [];
      this.receivables = [];
      this.leases = [];
      this.totalDepositPaid = 0;
      await this.getBalanceSheet();
    },
  },
  computed: {
    exportDisabled() {
      return !(this.date && (this.facilityAccounts.length || this.deposits.length));
    },
  },
  data() {
    return {
      facilityAccounts: [],
      deposits: [],
      receivables: [],
      leases: [],
      customers: [],
      totalDepositPaid: 0,
      totalPrepaidRent: 0,
      loading: false,
      date: null,
      totalOverpayedBalance: 0,
      totalReceivables: 0,
      walletBalance: 0,
    };
  },
  methods: {
    compareRow(prop, item1, item2) {
      switch (prop) {
        case 'balance': return item1.balance - item2.balance;
        case 'totalDepositPaid': return item1.totalDepositPaid - item2.totalDepositPaid;
        case 'totalDue': return item1.totalDue - item2.totalDue;
        default: return item1 - item2;
      }
    },
    sortTable({ prop, order }, data) {
      if (order === 'descending') {
        data.sort((item1, item2) => this.compareRow(prop, item2, item1));
      } else {
        data.sort((item1, item2) => this.compareRow(prop, item1, item2));
      }
    },
    routeToCustomer(row) {
      const customerId = row.customerData ? row.customerData._id : row.customerData._id;

      if (this.facility) {
        this.$router.push({ name: 'Facility Customer', params: { id: customerId, facility: this.facility } });
        return;
      }
      this.$router.push({ name: 'Customer', params: { id: customerId } });
    },
    async getBalanceSheet() {
      this.loading = true;
      const response = await axios.get(
        `${ADMIN_API_BASE}/facilities/${this.facility}/balance/sheet`,
        {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
          ...(this.date ? {
            params: {
              month: this.date.getMonth(),
              year: this.date.getFullYear(),
            },
          } : {}),
        },
      );

      this.facilityAccounts = response.data.facilityAccounts;
      this.deposits = response.data.deposits;
      this.receivables = response.data.receivables;
      this.leases = response.data.leases;
      this.customers = response.data.customers;
      this.walletBalance = response.data.totalWalletBalance;
      this.totalDepositPaid = response.data.totalDepositPaid;
      this.totalOverpayedBalance = response.data.totalOverpayedBalance;
      this.totalReceivables = response.data.totalReceivables;
      this.totalPrepaidRent = response.data.totalPrepaidRent;
      this.loading = false;
    },
    getCustomerCompany(id) {
      const [foundCustomer] = this.customers.filter(item => item._id === id);

      if (foundCustomer) {
        return foundCustomer.company;
      }
      return '';
    },
    exportData() {
      const csvData = {};
      this.deposits.forEach((dep) => {
        if (dep._id.customerId) {
          csvData[dep._id.customerId] = {
            name: dep.customerData && dep.customerData.company ? dep.customerData.company.replaceAll(',', '') : '--',
            depositPaid: dep.totalDepositPaid,
            amount: 0,
            receivable: 0,
          };
        }
      });
      this.facilityAccounts.forEach((acc) => {
        if (acc.customer) {
          if (csvData[acc.customer]) {
            csvData[acc.customer] = {
              ...csvData[acc.customer],
              amount: acc.balance,
            };
          } else {
            csvData[acc.customer] = {
              name: acc.customerData && acc.customerData.company ? acc.customerData.company.replaceAll(',', '') : '--',
              depositPaid: 0,
              receivable: 0,
              amount: acc.balance,
            };
          }
        }
      });
      this.receivables.forEach((rec) => {
        if (rec._id.customerId) {
          if (csvData[rec._id.customerId]) {
            csvData[rec._id.customerId] = {
              ...csvData[rec._id.customerId],
              receivable: rec.totalDue,
            };
          } else {
            csvData[rec._id.customerId] = {
              name: rec.customerData && rec.customerData.company ? rec.customerData.company.replaceAll(',', '') : '--',
              depositPaid: 0,
              amount: 0,
              receivable: rec.totalDue,
            };
          }
        }
      });

      const data = Object.values(csvData);

      const balanceSheetCsv = exportToCsvV2({
        name: 'Company',
        depositPaid: 'Deposit Paid',
        amount: 'Wallet Amount',
        receivable: 'Receivable',
      }, data);

      saveCsv(balanceSheetCsv, `financials_balance_sheet_${this.date.getMonth() + 1}-${this.date.getFullYear()}`);
    },
    setDate(date) {
      this.date = date;
    },
  },
};
</script>

<style scoped>

.date-picker{
  padding-bottom: 15px;
}

.hero-text {
  color: #efefef;
  font-weight: 300;
}

.hero-head {
  font-weight: 400;
  margin: 0;
  color: #009aca;
}

</style>



// WEBPACK FOOTER //
// src/components/FinanceBalanceSheet.vue